import React from 'react';
import { Users, Stethoscope, Leaf, ShieldCheck } from 'lucide-react';
const trustItems = [{
  icon: Users,
  text: '100.000+ zufriedene Kunden'
}, {
  icon: Stethoscope,
  text: 'Von Tierärzten empfohlen'
}, {
  icon: Leaf,
  text: '100% pflanzlich & natürlich'
}, {
  icon: ShieldCheck,
  text: 'Geld-zurück-Garantie'
}];
export function TrustBar() {
  return <section className="w-full bg-forest text-cream py-8 mb-12" data-id="element-150">
      <div className="max-w-2xl mx-auto px-4" data-id="element-151">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center" data-id="element-152">
          {trustItems.map((item, index) => <div key={index} className="flex flex-col items-center gap-2" data-id="element-153">
              <item.icon size={28} className="text-cream/90" data-id="element-154" />
              <span className="font-serif text-xs md:text-sm font-medium leading-tight" data-id="element-155">
                {item.text}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}